import { useState } from "react";
import { History, RotateCcw, ChevronDown, ChevronUp } from "lucide-react";

const ACTION = { save: "Modifica", reset: "Valori iniziali", restore: "Ripristino" };

const fmt = (v) => {
  if (v === undefined || v === null || v === "") return "—";
  if (Array.isArray(v)) return v.length ? v.join(", ") : "—";
  if (typeof v === "boolean") return v ? "Sì" : "No";
  return String(v);
};

const when = (ts) => new Date(ts).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

const Entry = ({ v, isCurrent, onRestore }) => {
  const [open, setOpen] = useState(false);
  return (
    <li className="border-t border-[#F2ECE4] py-3" data-testid={`rules-history-item-${v.id}`}>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-sm">
            <span className="text-[10px] tracking-[0.18em] uppercase text-[#C5A059] mr-2">{ACTION[v.action] || v.action}</span>
            <span data-testid={`rules-history-when-${v.id}`}>{when(v.ts)}</span>
            <span className="text-[#8C8275]"> · </span>
            <span data-testid={`rules-history-user-${v.id}`}>{v.user_name}</span>
          </p>
          <p className="text-xs text-[#8C8275] mt-0.5">{v.note || `${v.changes.length} ${v.changes.length === 1 ? "campo modificato" : "campi modificati"}`}</p>
        </div>
        <div className="flex items-center gap-2">
          <button data-testid={`rules-history-toggle-${v.id}`} className="text-xs text-[#595652] hover:text-[#1A1A18] inline-flex items-center gap-1" onClick={() => setOpen((o) => !o)}>
            {open ? <ChevronUp size={14} /> : <ChevronDown size={14} />} Dettagli
          </button>
          {isCurrent ? (
            <span className="text-xs text-[#8C8275] px-2 py-1 border border-[#E2DACF]" data-testid={`rules-history-current-${v.id}`}>Versione attuale</span>
          ) : (
            <button data-testid={`rules-history-restore-${v.id}`} className="fs-btn-ghost !py-1 !px-2 text-xs" onClick={() => onRestore(v)}><RotateCcw size={12} /> Ripristina</button>
          )}
        </div>
      </div>
      {open && (
        <ul className="mt-3 space-y-1.5 text-xs" data-testid={`rules-history-changes-${v.id}`}>
          {v.changes.length === 0 && <li className="text-[#8C8275]">Nessuna differenza registrata.</li>}
          {v.changes.map((c) => (
            <li key={c.label} className="grid sm:grid-cols-[180px_1fr] gap-1 sm:gap-3">
              <span className="text-[#595652]">{c.label}</span>
              <span><span className="line-through text-[#8C8275] break-words">{fmt(c.before)}</span> <span className="text-[#C5A059]">→</span> <span className="break-words">{fmt(c.after)}</span></span>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

export const RulesHistory = ({ items, onRestore }) => (
  <section className="bg-white border border-[#E2DACF] p-6" data-testid="rules-history">
    <div className="flex items-center gap-2 mb-1"><History size={16} className="text-[#C5A059]" /><p className="font-serif text-xl">Storico modifiche</p></div>
    <p className="text-xs text-[#8C8275] mb-3 max-w-2xl">Ogni salvataggio registra chi ha cambiato cosa e quando. Puoi ripristinare una versione precedente: il ripristino viene a sua volta registrato.</p>
    {items.length === 0 ? (
      <p className="text-sm text-[#8C8275]" data-testid="rules-history-empty">Nessuna modifica registrata finora.</p>
    ) : (
      <ul>{items.map((v, i) => <Entry key={v.id} v={v} isCurrent={i === 0} onRestore={onRestore} />)}</ul>
    )}
  </section>
);
